"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styled_1 = __importDefault(require("@seaweb/coral/hoc/styled"));
var react_spring_1 = require("react-spring");
var useForkRef_1 = require("@seaweb/coral/hooks/useForkRef");
var Item = styled_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: fit-content;\n  will-change: opacity, height, padding;\n  box-sizing: content-box;\n"], ["\n  width: fit-content;\n  will-change: opacity, height, padding;\n  box-sizing: content-box;\n"])));
var AnimatedItem = react_spring_1.animated(Item);
var PusherItem = react_1.forwardRef(function PusherItem(_a, ref) {
    var as = _a.as, children = _a.children, style = _a.style, pop = _a.pop, pause = _a.pause, resume = _a.resume, elementsRef = _a.elementsRef, queueKey = _a.queueKey, props = __rest(_a, ["as", "children", "style", "pop", "pause", "resume", "elementsRef", "queueKey"]);
    var handleRef = function (dom) {
        elementsRef.current[queueKey] = dom;
    };
    return (react_1.default.createElement(AnimatedItem, __assign({ as: as, ref: ref, style: style, onMouseEnter: pause, onMouseLeave: resume }, props), typeof children === 'function'
        ? children({
            pop: pop,
            pause: pause,
            resume: resume,
            ref: handleRef,
        })
        : react_1.cloneElement(react_1.Children.only(children), {
            ref: function (dom) {
                var childRef = children.ref;
                if (childRef)
                    useForkRef_1.setRef(childRef, dom);
                handleRef(dom);
            },
        })));
});
exports.default = react_1.memo(PusherItem);
var templateObject_1;
